import { SupportModel } from '@shared/models/Support';
import { ISupportService } from '@shared/interfaces/services';
import { ApiService } from '@shared/services';

export class SupportService extends ApiService implements ISupportService {
  constructor() {
    super('/support');
  }

  sendPublicMessage(entity: SupportModel): Promise<void> {
    return this.post('/public/email', entity);
  }

  sendPrivateSupportMessage(entity: SupportModel): Promise<void> {
    return this.post('/email', entity);
  }
}
